import React from 'react'
import styled from 'styled-components'

const StyledI = styled.img`
  margin-bottom: 15px;
  width: 20px;
  height: 20px;
  margin-top: 5px;
  position: absolute;
  display: ${({ docked }) => (docked ? 'flex' : 'none')};
  ${({ left }) => (left ? 'left' : 'right')}: 10px;
  top: 10px;
  &:hover {
    cursor: pointer;
  }
`

class CollapseSidebarIcon extends React.Component {
  render() {
    return (
      <StyledI
        onClick={this.props.toggleDocked}
        docked={this.props.docked}
        left={this.props.left}
        src="/static/collapse.png"
      />
    )
  }
}

export default CollapseSidebarIcon
